<h2 mat-dialog-title>Filtros avançados</h2>

<mat-dialog-content class="filters-grid" [formGroup]="form">
  <mat-form-field appearance="outline">
    <mat-label>Médico</mat-label>
    <mat-select formControlName="doctorId">
      <mat-option [value]="null">Todos</mat-option>
      <mat-option
        *ngFor="let doctor of doctors"
        [value]="doctor.id"
      >
        {{ doctor.name }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Status da NFSe</mat-label>
    <mat-select formControlName="nfseStatus">
      <mat-option *ngFor="let opt of nfseStatusOptions" [value]="opt.value">
        {{ opt.label }}
      </mat-option>
    </mat-select>
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="close()">Cancelar</button>
  <button mat-flat-button color="primary" type="button" (click)="apply()">
    Aplicar filtros
  </button>
</mat-dialog-actions>
